
export class CompanyIdDateRangeRequest {
    companyId: number;
    fromDate: string;
    toDate: string;

    /**
     * 
     * @param companyId 
     * @param fromDate 
     * @param toDate 
     */
    constructor(companyId: number, fromDate: string, toDate: string) {
        this.companyId = companyId;
        this.fromDate = fromDate;
        this.toDate = toDate;
    }
}